import React from 'react';

import SkeletonSuggestionCard from './SkeletonSuggestionCard.jsx';

type Props = {
  isRecoRobot?: boolean;
};

const SkeletonCards = ({ isRecoRobot }: Props) => {
  return (
    <>
      <SkeletonSuggestionCard />
      <SkeletonSuggestionCard />
      <SkeletonSuggestionCard />
      <SkeletonSuggestionCard />
      <SkeletonSuggestionCard />
      {isRecoRobot && <SkeletonSuggestionCard />}
    </>
  );
};

export default SkeletonCards;
